import { PARTNER_FORM_STATUS_TYPES } from '@atlassian/mpac-api-client';
import React from 'react';
import PrivacyAndSecurityForm from '../../PartnerComponents/PrivacyAndSecurityForm';
import PrivacyAndSecurityPreview from '../../PartnerComponents/PrivacyAndSecurityPreview';
import PrivacyAndSecurityPreviewAndPublish from '../../PartnerComponents/PrivacyAndSecurityPreviewAndPublish';
import { PARTNER_TRUST_APP_PREVIEW_MODES } from '../constants';
const RenderByPriority = _ref => {
  let {
    currentMode,
    liveAppTrustData,
    draftAppTrustData,
    appListingData,
    appName,
    onEdit,
    onPublish,
    onSave,
    onDiscard
  } = _ref;
  // currentMode > appTrustData.properties --> currentMode overwites the default behaviour
  if (currentMode === PARTNER_TRUST_APP_PREVIEW_MODES.PREVIEW_ONLY) {
    // PREVIEW READ ONLY
    return /*#__PURE__*/React.createElement(PrivacyAndSecurityPreview, {
      draftAppTrustData: draftAppTrustData,
      liveAppTrustData: liveAppTrustData,
      appListingData: appListingData,
      appName: appName,
      onEdit: onEdit
    });
  } else if (currentMode === PARTNER_TRUST_APP_PREVIEW_MODES.PREVIEW_AND_PUBLISH) {
    // PREVIEW AND PUBLISH
    return /*#__PURE__*/React.createElement(PrivacyAndSecurityPreviewAndPublish, {
      appListingData: appListingData,
      appTrustData: draftAppTrustData,
      appName: appName,
      onEdit: onEdit,
      onPublish: onPublish
    });
  } else if (currentMode === PARTNER_TRUST_APP_PREVIEW_MODES.PARTNER_FORM) {
    // PARTNER FORM
    return /*#__PURE__*/React.createElement(PrivacyAndSecurityForm, {
      onDiscard: onDiscard,
      onSave: onSave,
      draftAppTrustData: draftAppTrustData,
      liveAppTrustData: liveAppTrustData
    });
  }
  // 👇 conditions based on data's state
  else if ((liveAppTrustData === null || liveAppTrustData === void 0 ? void 0 : liveAppTrustData.properties.formStatus) === PARTNER_FORM_STATUS_TYPES.SUBMITTED || (liveAppTrustData === null || liveAppTrustData === void 0 ? void 0 : liveAppTrustData.properties.formStatus) === PARTNER_FORM_STATUS_TYPES.APPROVED) {
    // PREVIEW READ ONLY
    return /*#__PURE__*/React.createElement(PrivacyAndSecurityPreview, {
      draftAppTrustData: draftAppTrustData,
      liveAppTrustData: liveAppTrustData,
      appListingData: appListingData,
      appName: appName,
      onEdit: onEdit
    });
  }
  return /*#__PURE__*/React.createElement(PrivacyAndSecurityForm, {
    onDiscard: onDiscard,
    onSave: onSave,
    draftAppTrustData: draftAppTrustData,
    liveAppTrustData: liveAppTrustData
  });
};
export default RenderByPriority;